import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "input-field" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "input-warp" }
const _hoisted_4 = ["type", "placeholder"]
const _hoisted_5 = ["type", "placeholder"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.disabled)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: _ctx.inputType,
            placeholder: _ctx.hint,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            disabled: ""
          }, null, 8, _hoisted_4)), [
            [_vModelDynamic, _ctx.value]
          ])
        : _createCommentVNode("", true),
      (!_ctx.disabled)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: _ctx.inputType,
            placeholder: _ctx.hint,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event))
          }, null, 8, _hoisted_5)), [
            [_vModelDynamic, _ctx.value]
          ])
        : _createCommentVNode("", true),
      (_ctx.type==='password')
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            class: "swiitch",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.swiitchVisibility && _ctx.swiitchVisibility(...args))),
            src: _ctx.switchSrc
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}